module.exports = __webpack_public_path__ + "media/logos/google-badge-624df808.svg";